import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getNotificationPreferences } from '@/services/notifications/get-notification-preferences';
import { NotificationPreferencesResponse } from '@/types/notification-types';
import { useOrgStore } from '@/stores/org-store';

export const NOTIFICATION_PREFERENCES_QUERY_KEY = 'notification-preferences';

export const useGetNotificationPreferences = (
  options?: Partial<UseQueryOptions<NotificationPreferencesResponse, Error>>,
) => {
  const { currentOrg } = useOrgStore();
  const orgId = currentOrg?.orgid;

  return useQuery<NotificationPreferencesResponse, Error>({
    queryKey: [NOTIFICATION_PREFERENCES_QUERY_KEY, orgId],
    queryFn: ({ signal }) => getNotificationPreferences(orgId!, signal),
    enabled: !!orgId,
    ...options,
  });
};
